interface IntegerInputProps {
  id: string;
  min: number;
  max: number;
  label?: string;
  labelColour?: string;
  className: string;
  ariaLabel?: string;
  placeholder?: string;
  autoComplete?: string;
  required?: boolean;
  children?: React.ReactNode;
  showLabel?: boolean;
  state?: any;
  stateName?: any;
  onChange?: any;
  disabled?: boolean;
}

export default function IntegerInput({
  id,
  min,
  max,
  label,
  labelColour,
  className,
  ariaLabel,
  placeholder,
  autoComplete,
  required,
  children,
  showLabel,
  state,
  stateName,
  onChange,
  disabled,
}: IntegerInputProps) {
  return (
    <div>
      {showLabel ? (
        <label
          htmlFor={id}
          className={`mb-3 block text-left text-sm font-medium ${labelColour}`}
        >
          {label}
        </label>
      ) : (
        <label
          htmlFor={id}
          className={`mb-3 block text-left text-sm font-medium ${labelColour}`}
        />
      )}
      {disabled ? (
        <input
          id={id}
          type="number"
          min={min}
          max={max}
          className={className}
          placeholder={placeholder}
          aria-label={ariaLabel}
          autoComplete={autoComplete}
          required={required}
          onChange={(e) =>
            onChange({ ...state, [stateName]: parseInt(e.target.value) })
          }
          value={state[stateName]}
          disabled
        >
          {children}
        </input>
      ) : (
        <input
          id={id}
          type="number"
          min={min}
          max={max}
          className={className}
          placeholder={placeholder}
          aria-label={ariaLabel}
          autoComplete={autoComplete}
          value={state[stateName]}
          required={required}
          onChange={(e) =>
            onChange({ ...state, [stateName]: parseInt(e.target.value) })
          }
        >
          {children}
        </input>
      )}
    </div>
  );
}

IntegerInput.defaultProps = {
  ariaLabel: "",
  labelColour: "text-black",
  placeholder: "",
  autoComplete: "",
  required: true,
  showLabel: false,
  state: {},
  stateName: "",
  onChange: () => {},
  disabled: false,
};
